import React from "react";
import styled from "styled-components";

const StyledCard = styled.div`
  ${({ flex }) => {
    if (flex) {
      return `flex: ${flex}`;
    }
  }};

  ${({ width }) => {
    if (width) {
      return `width: ${width}`;
    }
  }};

  box-sizing: border-box;
  margin: 1rem;
  padding: 0 1rem;
  border: 1px solid #ababab;

  box-shadow: 0 0 10px #ababab;

  background-color: #ededed;

  .header {
    border-bottom: 1px solid #989898;

    margin: 0;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;

    text-align: center;
  }

  a {
    color: rgb(255, 60, 60);
  }
`;

const Card = props => {
  return (
    <StyledCard flex={props.flex}>
      <h1 className="header">{props.header}</h1>
      {props.children}
    </StyledCard>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js